// Board dropdown labels. A cloudtv-signed board (keymd5 starts with FD889) is
// shown bare; anything else is OEM and gets an "O- " tag.
export const boardLabel = (board, keymd5) =>
    (String(keymd5 || '').startsWith('FD889') ? '' : 'O- ') + board;

// Reverse of boardLabel: the plain board name to send/store.
// "(CLOUDTV) "/"(OEM) " are the older tags, still stripped.
export const boardName = v => String(v == null ? '' : v)
    .replace(/^\s*(?:O-|\(O-\)|\(OEM\)|\(CLOUDTV\))\s+/, '').trim();
